// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__xVelh","buttons":"RemoveExpirationActionButtons_buttons__3DgvD"};